import type { AsdDuration, AsdOffer, AsdOffersResponse, AsdTier } from '~/types/asd'

export function getAllOffers(offers: AsdOffersResponse | null | undefined): AsdOffer[] {
    if (!offers) return []
    return [...offers.live, ...offers.archive]
}

export function isPeriodDateWithinOffer(periodDate: string, offer: AsdOffer): boolean {
    return periodDate >= offer.period_start && periodDate <= offer.period_end
}

export function findOffersForPeriodDate(
    offers: AsdOffersResponse | null | undefined,
    periodDate: string,
): AsdOffer[] {
    return getAllOffers(offers).filter(
        (offer) => !offer.owned && isPeriodDateWithinOffer(periodDate, offer),
    )
}

export function filterOffersByDuration(
    offers: AsdOffer[],
    duration: AsdDuration | '' | null | undefined,
): AsdOffer[] {
    if (!duration) return offers
    return offers.filter((offer) => offer.duration === duration)
}

export function filterOffersByTier(
    offers: AsdOffer[],
    tier: AsdTier | '' | null | undefined,
): AsdOffer[] {
    if (!tier) return offers
    return offers.filter((offer) => offer.tier === tier)
}

export function filterOffersByYear(
    offers: AsdOffer[],
    year: number | string | null | undefined,
): AsdOffer[] {
    if (!year) return offers
    const yearValue = Number(year)
    if (!yearValue) return offers
    return offers.filter((offer) => Number(offer.period_start.slice(0, 4)) === yearValue)
}

export function getArchiveYears(offers: AsdOffer[]): number[] {
    const years = new Set<number>()
    for (const offer of offers) {
        years.add(Number(offer.period_start.slice(0, 4)))
    }
    return [...years].sort((a, b) => b - a)
}

export function buildOffersPageQuery(params: {
    athleteId?: number | string
    periodDate?: string | null
    offerId?: number | null
}): Record<string, string> {
    const query: Record<string, string> = {}
    if (params.athleteId != null) {
        query.athlete_id = String(params.athleteId)
    }
    if (params.periodDate) {
        query.period_date = params.periodDate
    }
    if (params.offerId != null) {
        query.offer_id = String(params.offerId)
    }
    return query
}
